import { enableFade } from 'core/handlers/FadeHandler'
import { signal } from 'services/SignalsService'

export default class PaytableEntity extends PIXI.Container {
  constructor() {
    super()
    const fade = enableFade(this)
    signal.on('RADIO:menu', (value) => {
      fade(value == 'paytable')
    })
  }
}
